import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import { theme, Icon, Spinner, DatePicker } from 'fpay-ui';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getFormatedDate } from '@helpers';

const StyledDatePicker = styled.div`
  min-height: 36px;
  #btn-drop-down-calendar {
    display: none;
  }

  > div:first-child {
    ::before {
      display: none;
      ${({ theme }) => theme.breakpoint(null, 'md')} {
        display: ${({ show }) => (show ? 'unset' : 'none')};
      }
      content: '';
      background-color: #444b62;
      position: fixed;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      z-index: -1;
      opacity: 70%;
      transition: opacity 1s ease-out;
    }
    ${({ theme }) => theme.breakpoint('sm', 'md')} {
      > div {
        bottom: unset;
        border-radius: 5px;
        margin: 0px;
        > div:nth-child(4) {
          padding-top: 16px;
        }
      }
    }
  }
`;

const StyledFilter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: solid 1px #caced8;
  ${({ theme }) => theme.breakpoint('md')} {
    min-width: 300px;
    width: auto;
    margin-top: 16px;
  }
`;

const SyledDateContainer = styled.div`
  display: flex;
  min-width: 200px;
  cursor: pointer;
  margin-left: 8px;
  margin-right: 8px;
  justify-content: space-between;
  width: 100%;
`;

const ContainerSpinner = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 100px;
`;

const IconButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  & svg {
    vertical-align: middle;
  }
`;

const StyledDateFilter = styled.div`
  width: 100%;
  font-size: 14px;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    font-size: 12px;
  }
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: left;
  color: var(--light_grey_blue);
  padding-left: 16px;
  padding-right: 16px;
`;

const fontTypes = {
  button: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: normal;
  `,
};

const Title = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 21px;
  color: #444b62;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 32px 16px 32px 16px;
  flex-direction: column;
`;
const List = styled.ul`
  margin-left: 16px;
`;

const Text = styled.li`
  font-size: 14px;
  color: #444b62;
  font-weight: 400;
`;
const Button = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    ${fontTypes.button}
    text-align: center;
    align-items: center;
    width: 97px;
    height: 48px;
    border-radius: 6px;
    pointer-events: ${(props) => props.disabled && 'none'};
    background-color: ${(props) =>
      props.noThanks ? '#ffffff' : props.disabled ? '#E4E6EB' : `${theme.colors.gbrand500}`};
    color: ${(props) =>
      props.noThanks ? `${theme.colors.gbrand500}` : props.disabled ? '#A2A7BA' : '#ffffff'};
    cursor: pointer;
    transition: all 0.3s ease 0s;
    &:hover {
      box-shadow: ${(props) => (props.noThanks ? '' : '0 1px 6px rgb(32 33 36 / 28%)')};
      background-color: ${(props) => (props.noThanks ? '' : `${theme.colors.gbrand600}`)};
      color: ${(props) => (props.noThanks ? `${theme.colors.gbrand600}` : '#ffffff')};
    }
    &:active {
      border: ${(props) => (props.noThanks ? '' : `1px solid ${theme.colors.gbrand500}`)};
    }
  `
);

const ConstainerButtons = styled.div`
  display: ${(props) => (props.isCreating ? 'none' : 'flex')};
  width: 100%;
  justify-content: center;
  margin-top: -370px;
  ${theme.breakpoint('md')} {
    justify-content: flex-end;
    margin-top: -168px;
  }
`;

const CreateReportsForRangeTime = ({ handleClose, handleCreate }) => {
  const { created_at: createdAt, seller } = useSelector((state) => state.login.merchant);
  const { email } = useSelector((state) => state.login.loguedAs);
  const { limit_search_report: limitSearchReport } = useSelector((state) => state.config);
  const { spinner: isCreating } = useSelector((state) => state.reports);
  const [showCalendar, setShowCalendar] = useState(false);

  const [intervalDate, setIntervalDate] = useState({ start: undefined, end: null });

  const [filterApply, setFilterApply] = useState(false);

  const handleChange = ({ init: start, finish: end }) => {
    setIntervalDate({ start, end });
    setFilterApply(true);
  };

  const handleReset = () => {
    setFilterApply(false);
    setIntervalDate({ start: undefined, end: null });
  };

  const { t } = useTranslation();

  return (
    <>
      <Container>
        {isCreating ? (
          <ContainerSpinner>
            <Spinner leyend="Generando reporte" />
          </ContainerSpinner>
        ) : (
          <>
            <Title>{t('reportsScreen.titleTime')}</Title>
            <List>
              <Text>
                {' '}
                {t('reportsScreen.createReport.textDescription', {
                  limitDays:
                    limitSearchReport && seller.length
                      ? limitSearchReport[seller]
                      : limitSearchReport['ON THEM'],
                })}
              </Text>
              <Text>
                {t('reportsScreen.sendMail')}
                <b>{email}</b>
              </Text>
              <Text>
                {t('reportsScreen.findSection')}
                <b>{t('reportsScreen.reports')}</b>
              </Text>
            </List>

            <StyledFilter>
              <SyledDateContainer>
                <IconButton onClick={() => setShowCalendar((state) => !state)}>
                  <Icon icon="ic-calendar" />
                </IconButton>
                <StyledDateFilter type="button" onClick={() => setShowCalendar((state) => !state)}>
                  {filterApply
                    ? `${getFormatedDate(intervalDate.start, 'dd/MM/yyyy')} a ${getFormatedDate(
                        intervalDate.end,
                        'dd/MM/yyyy'
                      )}`
                    : t('transactions.report.selectDate')}
                </StyledDateFilter>
                {filterApply && (
                  <IconButton onClick={handleReset}>
                    <Icon id="img-cerrar-x" icon="ic-close-circle" />
                  </IconButton>
                )}
              </SyledDateContainer>
            </StyledFilter>

            <StyledDatePicker show={showCalendar}>
              <DatePicker
                show={showCalendar}
                setShow={setShowCalendar}
                onChange={handleChange}
                intervalDateSelect={intervalDate}
                placeholder="Seleccionar fecha"
                minDate={moment(createdAt).toDate()}
                maxDate={moment().toDate()}
                limitDays={
                  limitSearchReport && seller.length
                    ? limitSearchReport[seller]
                    : limitSearchReport['ON THEM']
                }
                position="relative"
                positionMd="relative"
                width="312px"
                top="-250px"
                left="-28px"
                marginTop="-220px"
                showCloseMobile={false}
                showLimitDaysInterval={false}
                positionContainer="inherit"
                widthMD="344px"
                height="380px"
                heightMD="400px"
              />
            </StyledDatePicker>
          </>
        )}
        <ConstainerButtons isCreating={isCreating}>
          <Button noThanks onClick={handleClose} id="cancel-create-report">
            {t('reportsScreen.cancel')}
          </Button>
          <Button
            onClick={() => handleCreate(intervalDate)}
            disabled={!filterApply}
            id="confirm-create-report"
          >
            {t('reportsScreen.continue')}
          </Button>
        </ConstainerButtons>
      </Container>
    </>
  );
};

export default CreateReportsForRangeTime;
